import { createRoot } from 'react-dom/client';
import { HashRouter, Route, Routes } from 'react-router-dom';

import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import { ConfirmPopup } from 'primereact/confirmpopup';
import { AppConfirmDialog, DefaultConf, ScrollToTop } from '@iamsoftware/react-hooks';

import './assets/layout/layout.scss';
import '@iamsoftware/react-hooks/assets/style.scss';
import './App.scss';
import './assets/theme/atlantis-inspired.scss';

import { PrimeReactProvider } from 'primereact/api';

import { LayoutProvider } from 'src/layout/context/layoutcontext';

import { AppLoading } from 'src/AppLoading';
import { SafeAppToast } from 'src/components/SafeAppToast';

import App from 'src/app';
import Login from 'src/pages/login';
import SsoCallback from 'src/pages/login/SsoCallback';
import { Sign } from './pages/ky-hop-dong';

document.documentElement.style.fontSize = '14px';

DefaultConf.DataTable.IndexColumnHeader = 'STT';
DefaultConf.DataTable.ItemsField = 'listData';

const root = createRoot(
  document.getElementById('root') as HTMLElement
);

const callbackSearchParams = new URLSearchParams(window.location.search);
if ((callbackSearchParams.has('code') || callbackSearchParams.has('error')) && !window.location.hash.includes('/sso-callback')) {
  window.history.replaceState(null, '', `${window.location.pathname}#/sso-callback${window.location.search}`);
}

root.render(

  <HashRouter>
    <ScrollToTop>
      <PrimeReactProvider>
        <LayoutProvider>
          <ConfirmPopup />
          <Routes>
            <Route path="login" element={<Login />} />
            <Route path="sso-callback" element={<SsoCallback />} />
            <Route path="ky-hop-dong" element={<Sign />} />
            <Route path="*" element={<App />} />
          </Routes>
          <AppLoading />
          <SafeAppToast />
          <AppConfirmDialog />
        </LayoutProvider>
      </PrimeReactProvider>
    </ScrollToTop>
  </HashRouter>
);
